"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mathjs_1 = require("mathjs");
var rand_1 = require("./tools/rand");
var organism_1 = __importDefault(require("./organism"));
var equipment_1 = __importDefault(require("./equipment"));
var config_1 = __importDefault(require("../config"));
var names_1 = require("./data/names");
var types_1 = require("./data/types");
var rand_2 = require("../../map-generator/src/tools/rand");
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? rand_1.getRandomArrayItem({
            array: names_1.FirstNames
        }) + " " + rand_1.getRandomArrayItem({
            array: names_1.SurNames
        }) : _c, 
        // stats
        _d = _b.hp, 
        // stats
        hp = _d === void 0 ? config_1.default.playerInitialHp : _d, _e = _b.sta, sta = _e === void 0 ? config_1.default.playerInitialSta : _e, 
        // physical attack power
        _f = _b.str, 
        // physical attack power
        str = _f === void 0 ? rand_1.getRandomInt(config_1.default.playerInitialStrFrom, config_1.default.playerInitialStrTo) : _f, 
        // regeneration and hit points
        _g = _b.vit, 
        // regeneration and hit points
        vit = _g === void 0 ? rand_1.getRandomInt(config_1.default.playerInitialVitFrom, config_1.default.playerInitialVitTo) : _g, 
        // magic attack power
        _h = _b.int, 
        // magic attack power
        int = _h === void 0 ? rand_1.getRandomInt(config_1.default.playerInitialIntFrom, config_1.default.playerInitialIntTo) : _h, 
        // change to hit and forging powers
        _j = _b.dex, 
        // change to hit and forging powers
        dex = _j === void 0 ? rand_1.getRandomInt(config_1.default.playerInitialDexFrom, config_1.default.playerInitialDexTo) : _j, _k = _b.agi, agi = _k === void 0 ? rand_1.getRandomInt(config_1.default.playerInitialAgiFrom, config_1.default.playerInitialAgiTo) : _k;
        var _this = _super.call(this, {
            name: name,
            sta: sta,
            hp: hp,
        }) || this;
        _this.equipment = new equipment_1.default();
        _this._dex = dex;
        _this._str = str;
        _this._int = int;
        _this._vit = vit;
        _this._agi = agi;
        _this._class = types_1.Classes.Novice;
        _this.level = config_1.default.playerStartLevel;
        return _this;
    }
    Player.hydrate = function (obj) {
        var player = Object.assign(new Player(), obj);
        player.equipment = equipment_1.default.hydrate(obj.equipment);
        return player;
    };
    Player.prototype.levelUp = function () {
        _super.prototype.levelUp.call(this);
        this.hpMax = this.hpMax + (50 * mathjs_1.log(this.level, 10));
        this.hpCurrent = this.hpMax;
        // todo make this nicer
        /*
        this._vit *= this.level;
        this._agi *= this.level;
        this._int *= this.level;
        this._dex *= this.level;
        this._str *= this.level;
        */
        // evaluate class on level 10
        if (this.level === 10) {
            this._class = rand_2.getRandomEnumEntry({
                en: types_1.Classes,
                start: 1 // do not assign novice again
            });
        }
    };
    Player.prototype.tick = function (tick) {
        // do not tick when farming
        if (this.isFarming) {
            return;
        }
        // regenerate stamina
        if (this.staCurrent < this.staMax) {
            this.staCurrent += 0.10;
            if (this.staCurrent > this.staMax) {
                this.staCurrent = this.staMax;
            }
        }
        // regenerate hp
        if (this.hpCurrent < this.hpMax) {
            this.hpCurrent += (0.50 * this.vit());
            if (this.hpCurrent > this.hpMax) {
                this.hpCurrent = this.hpMax;
            }
        }
        this.equipment.tick();
    };
    Player.prototype.className = function () {
        return names_1.ClassNames[this._class];
    };
    Player.prototype.dex = function () {
        return this._dex;
    };
    Player.prototype.agi = function () {
        return this._agi;
    };
    Player.prototype.int = function () {
        return this._int;
    };
    Player.prototype.str = function () {
        return this._str;
    };
    Player.prototype.vit = function () {
        return this._vit;
    };
    Player.prototype.atk = function () {
        var e_1, _a;
        var atk = 0;
        try {
            for (var _b = __values(this.equipment.getEquipped()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var equipment = _c.value;
                if (equipment.atk) {
                    atk += equipment.atk() * this.str();
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return atk;
    };
    Player.prototype.matk = function () {
        var e_2, _a;
        var matk = 0;
        try {
            for (var _b = __values(this.equipment.getEquipped()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var equipment = _c.value;
                if (equipment.matk) {
                    matk += equipment.matk() * this.int();
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return matk;
    };
    Player.prototype.def = function () {
        var e_3, _a;
        var def = 0;
        try {
            for (var _b = __values(this.equipment.getEquipped()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var armor = _c.value;
                if (armor.def) {
                    def += armor.def() * this.vit();
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return def;
    };
    Player.prototype.mdef = function () {
        var e_4, _a;
        var mdef = 0;
        try {
            for (var _b = __values(this.equipment.getEquipped()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var equipment = _c.value;
                if (equipment.mdef) {
                    mdef += equipment.mdef() * this.int();
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return mdef;
    };
    Player.prototype.takeDamage = function (dmg) {
        var dead = _super.prototype.takeDamage.call(this, dmg);
        if (dead) {
            global.craeft.logs.push(this.className() + " " + this.name + " died!");
            global.craeft.stop(true);
        }
        return dead;
    };
    return Player;
}(organism_1.default));
exports.default = Player;
